"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Portal Dashboards API
 * API for analytics portal dashboards configurations.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicApi = exports.TopicApiFactory = exports.TopicApiFp = exports.TopicApiAxiosParamCreator = exports.ServerApi = exports.ServerApiFactory = exports.ServerApiFp = exports.ServerApiAxiosParamCreator = exports.GroupApi = exports.GroupApiFactory = exports.GroupApiFp = exports.GroupApiAxiosParamCreator = exports.DashboardApi = exports.DashboardApiFactory = exports.DashboardApiFp = exports.DashboardApiAxiosParamCreator = exports.RequestParameterLocationEnum = exports.DatetimeWidgetAllOfResolutionEnum = exports.DatetimeWidgetResolutionEnum = exports.DatetimeRangeWidgetAllOfResolutionEnum = exports.DatetimeRangeWidgetResolutionEnum = exports.ChartWidgetMarkerStyleEnum = exports.ChartWidgetLineStyleEnum = exports.ChartWidgetAxisXTypeEnum = exports.ChartWidgetAllOfTypeEnum = exports.ChartWidgetTypeEnum = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.ChartWidgetTypeEnum = {
    Line: 'line',
    Column: 'column',
    Bar: 'bar',
    Pie: 'pie'
};
exports.ChartWidgetAllOfTypeEnum = {
    Line: 'line',
    Column: 'column',
    Bar: 'bar',
    Pie: 'pie'
};
exports.ChartWidgetAxisXTypeEnum = {
    Number: 'number',
    Datetime: 'datetime',
    Category: 'category'
};
exports.ChartWidgetLineStyleEnum = {
    Solid: 'solid',
    Dash: 'dash',
    Dot: 'dot'
};
exports.ChartWidgetMarkerStyleEnum = {
    None: 'none',
    Circle: 'circle',
    Square: 'square',
    Triangle: 'triangle',
    Cross: 'cross'
};
exports.DatetimeRangeWidgetResolutionEnum = {
    Day: 'day',
    Time: 'time'
};
exports.DatetimeRangeWidgetAllOfResolutionEnum = {
    Day: 'day',
    Time: 'time'
};
exports.DatetimeWidgetResolutionEnum = {
    Day: 'day',
    Time: 'time'
};
exports.DatetimeWidgetAllOfResolutionEnum = {
    Day: 'day',
    Time: 'time'
};
exports.RequestParameterLocationEnum = {
    Path: 'path',
    Query: 'query'
};
/**
 * DashboardApi - axios parameter creator
 * @export
 */
const DashboardApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create dashboard.
         * @param {string} topicName Topic name.
         * @param {NewDashboard} [newDashboard] New dashboard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboard: (topicName, newDashboard, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('createDashboard', 'topicName', topicName);
            const localVarPath = `/topics/{topic-name}/dashboards`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(newDashboard, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete dashboard.
         * @param {string} topicName Topic name.
         * @param {string} dashboardName Dashboard name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboard: (topicName, dashboardName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('deleteDashboard', 'topicName', topicName);
            // verify required parameter 'dashboardName' is not null or undefined
            (0, common_1.assertParamExists)('deleteDashboard', 'dashboardName', dashboardName);
            const localVarPath = `/topics/{topic-name}/dashboards/{dashboard-name}`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)))
                .replace(`{${"dashboard-name"}}`, encodeURIComponent(String(dashboardName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get dashboard.
         * @param {string} topicName Topic name.
         * @param {string} dashboardName Dashboard name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard: (topicName, dashboardName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('getDashboard', 'topicName', topicName);
            // verify required parameter 'dashboardName' is not null or undefined
            (0, common_1.assertParamExists)('getDashboard', 'dashboardName', dashboardName);
            const localVarPath = `/topics/{topic-name}/dashboards/{dashboard-name}`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)))
                .replace(`{${"dashboard-name"}}`, encodeURIComponent(String(dashboardName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all dashboards.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDashboards: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all topic dashboards.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopicDashboards: (topicName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('listTopicDashboards', 'topicName', topicName);
            const localVarPath = `/topics/{topic-name}/dashboards`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update dashboard.
         * @param {string} topicName Topic name.
         * @param {string} dashboardName Dashboard name.
         * @param {DashboardUpdate} [dashboardUpdate] Dashboard update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard: (topicName, dashboardName, dashboardUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('updateDashboard', 'topicName', topicName);
            // verify required parameter 'dashboardName' is not null or undefined
            (0, common_1.assertParamExists)('updateDashboard', 'dashboardName', dashboardName);
            const localVarPath = `/topics/{topic-name}/dashboards/{dashboard-name}`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)))
                .replace(`{${"dashboard-name"}}`, encodeURIComponent(String(dashboardName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dashboardUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DashboardApiAxiosParamCreator = DashboardApiAxiosParamCreator;
/**
 * DashboardApi - functional programming interface
 * @export
 */
const DashboardApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DashboardApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create dashboard.
         * @param {string} topicName Topic name.
         * @param {NewDashboard} [newDashboard] New dashboard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboard(topicName, newDashboard, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createDashboard(topicName, newDashboard, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete dashboard.
         * @param {string} topicName Topic name.
         * @param {string} dashboardName Dashboard name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboard(topicName, dashboardName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteDashboard(topicName, dashboardName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get dashboard.
         * @param {string} topicName Topic name.
         * @param {string} dashboardName Dashboard name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard(topicName, dashboardName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDashboard(topicName, dashboardName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all dashboards.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDashboards(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listDashboards(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all topic dashboards.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopicDashboards(topicName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTopicDashboards(topicName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update dashboard.
         * @param {string} topicName Topic name.
         * @param {string} dashboardName Dashboard name.
         * @param {DashboardUpdate} [dashboardUpdate] Dashboard update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard(topicName, dashboardName, dashboardUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateDashboard(topicName, dashboardName, dashboardUpdate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.DashboardApiFp = DashboardApiFp;
/**
 * DashboardApi - factory interface
 * @export
 */
const DashboardApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DashboardApiFp)(configuration);
    return {
        /**
         *
         * @summary Create dashboard.
         * @param {string} topicName Topic name.
         * @param {NewDashboard} [newDashboard] New dashboard.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboard(topicName, newDashboard, options) {
            return localVarFp.createDashboard(topicName, newDashboard, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete dashboard.
         * @param {string} topicName Topic name.
         * @param {string} dashboardName Dashboard name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboard(topicName, dashboardName, options) {
            return localVarFp.deleteDashboard(topicName, dashboardName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get dashboard.
         * @param {string} topicName Topic name.
         * @param {string} dashboardName Dashboard name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard(topicName, dashboardName, options) {
            return localVarFp.getDashboard(topicName, dashboardName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all dashboards.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDashboards(options) {
            return localVarFp.listDashboards(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all topic dashboards.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopicDashboards(topicName, options) {
            return localVarFp.listTopicDashboards(topicName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update dashboard.
         * @param {string} topicName Topic name.
         * @param {string} dashboardName Dashboard name.
         * @param {DashboardUpdate} [dashboardUpdate] Dashboard update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard(topicName, dashboardName, dashboardUpdate, options) {
            return localVarFp.updateDashboard(topicName, dashboardName, dashboardUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DashboardApiFactory = DashboardApiFactory;
/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
class DashboardApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create dashboard.
     * @param {string} topicName Topic name.
     * @param {NewDashboard} [newDashboard] New dashboard.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    createDashboard(topicName, newDashboard, options) {
        return (0, exports.DashboardApiFp)(this.configuration).createDashboard(topicName, newDashboard, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete dashboard.
     * @param {string} topicName Topic name.
     * @param {string} dashboardName Dashboard name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    deleteDashboard(topicName, dashboardName, options) {
        return (0, exports.DashboardApiFp)(this.configuration).deleteDashboard(topicName, dashboardName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get dashboard.
     * @param {string} topicName Topic name.
     * @param {string} dashboardName Dashboard name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    getDashboard(topicName, dashboardName, options) {
        return (0, exports.DashboardApiFp)(this.configuration).getDashboard(topicName, dashboardName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all dashboards.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    listDashboards(options) {
        return (0, exports.DashboardApiFp)(this.configuration).listDashboards(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all topic dashboards.
     * @param {string} topicName Topic name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    listTopicDashboards(topicName, options) {
        return (0, exports.DashboardApiFp)(this.configuration).listTopicDashboards(topicName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update dashboard.
     * @param {string} topicName Topic name.
     * @param {string} dashboardName Dashboard name.
     * @param {DashboardUpdate} [dashboardUpdate] Dashboard update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    updateDashboard(topicName, dashboardName, dashboardUpdate, options) {
        return (0, exports.DashboardApiFp)(this.configuration).updateDashboard(topicName, dashboardName, dashboardUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DashboardApi = DashboardApi;
/**
 * GroupApi - axios parameter creator
 * @export
 */
const GroupApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create group.
         * @param {NewGroup} [newGroup] New group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: (newGroup, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(newGroup, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete group.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: (groupName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupName' is not null or undefined
            (0, common_1.assertParamExists)('deleteGroup', 'groupName', groupName);
            const localVarPath = `/groups/{group-name}`
                .replace(`{${"group-name"}}`, encodeURIComponent(String(groupName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get group.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup: (groupName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupName' is not null or undefined
            (0, common_1.assertParamExists)('getGroup', 'groupName', groupName);
            const localVarPath = `/groups/{group-name}`
                .replace(`{${"group-name"}}`, encodeURIComponent(String(groupName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the topic membership details.
         * @param {string} groupName Group name.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicMembershipOfGroup: (groupName, topicName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupName' is not null or undefined
            (0, common_1.assertParamExists)('getTopicMembershipOfGroup', 'groupName', groupName);
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('getTopicMembershipOfGroup', 'topicName', topicName);
            const localVarPath = `/groups/{group-name}/topic-memberships/{topic-name}`
                .replace(`{${"group-name"}}`, encodeURIComponent(String(groupName)))
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroups: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all topics the group is member of.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopicMembershipsByGroup: (groupName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupName' is not null or undefined
            (0, common_1.assertParamExists)('listTopicMembershipsByGroup', 'groupName', groupName);
            const localVarPath = `/groups/{group-name}/topic-memberships`
                .replace(`{${"group-name"}}`, encodeURIComponent(String(groupName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update group.
         * @param {string} groupName Group name.
         * @param {GroupUpdate} [groupUpdate] Group update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup: (groupName, groupUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'groupName' is not null or undefined
            (0, common_1.assertParamExists)('updateGroup', 'groupName', groupName);
            const localVarPath = `/groups/{group-name}`
                .replace(`{${"group-name"}}`, encodeURIComponent(String(groupName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(groupUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.GroupApiAxiosParamCreator = GroupApiAxiosParamCreator;
/**
 * GroupApi - functional programming interface
 * @export
 */
const GroupApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.GroupApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create group.
         * @param {NewGroup} [newGroup] New group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(newGroup, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createGroup(newGroup, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete group.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(groupName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteGroup(groupName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get group.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(groupName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGroup(groupName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the topic membership details.
         * @param {string} groupName Group name.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicMembershipOfGroup(groupName, topicName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTopicMembershipOfGroup(groupName, topicName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroups(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listGroups(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all topics the group is member of.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopicMembershipsByGroup(groupName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTopicMembershipsByGroup(groupName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update group.
         * @param {string} groupName Group name.
         * @param {GroupUpdate} [groupUpdate] Group update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(groupName, groupUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateGroup(groupName, groupUpdate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.GroupApiFp = GroupApiFp;
/**
 * GroupApi - factory interface
 * @export
 */
const GroupApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.GroupApiFp)(configuration);
    return {
        /**
         *
         * @summary Create group.
         * @param {NewGroup} [newGroup] New group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(newGroup, options) {
            return localVarFp.createGroup(newGroup, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete group.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(groupName, options) {
            return localVarFp.deleteGroup(groupName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get group.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(groupName, options) {
            return localVarFp.getGroup(groupName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the topic membership details.
         * @param {string} groupName Group name.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicMembershipOfGroup(groupName, topicName, options) {
            return localVarFp.getTopicMembershipOfGroup(groupName, topicName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroups(options) {
            return localVarFp.listGroups(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all topics the group is member of.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopicMembershipsByGroup(groupName, options) {
            return localVarFp.listTopicMembershipsByGroup(groupName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update group.
         * @param {string} groupName Group name.
         * @param {GroupUpdate} [groupUpdate] Group update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(groupName, groupUpdate, options) {
            return localVarFp.updateGroup(groupName, groupUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
exports.GroupApiFactory = GroupApiFactory;
/**
 * GroupApi - object-oriented interface
 * @export
 * @class GroupApi
 * @extends {BaseAPI}
 */
class GroupApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create group.
     * @param {NewGroup} [newGroup] New group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    createGroup(newGroup, options) {
        return (0, exports.GroupApiFp)(this.configuration).createGroup(newGroup, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete group.
     * @param {string} groupName Group name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    deleteGroup(groupName, options) {
        return (0, exports.GroupApiFp)(this.configuration).deleteGroup(groupName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get group.
     * @param {string} groupName Group name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    getGroup(groupName, options) {
        return (0, exports.GroupApiFp)(this.configuration).getGroup(groupName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the topic membership details.
     * @param {string} groupName Group name.
     * @param {string} topicName Topic name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    getTopicMembershipOfGroup(groupName, topicName, options) {
        return (0, exports.GroupApiFp)(this.configuration).getTopicMembershipOfGroup(groupName, topicName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all groups.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    listGroups(options) {
        return (0, exports.GroupApiFp)(this.configuration).listGroups(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all topics the group is member of.
     * @param {string} groupName Group name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    listTopicMembershipsByGroup(groupName, options) {
        return (0, exports.GroupApiFp)(this.configuration).listTopicMembershipsByGroup(groupName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update group.
     * @param {string} groupName Group name.
     * @param {GroupUpdate} [groupUpdate] Group update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    updateGroup(groupName, groupUpdate, options) {
        return (0, exports.GroupApiFp)(this.configuration).updateGroup(groupName, groupUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.GroupApi = GroupApi;
/**
 * ServerApi - axios parameter creator
 * @export
 */
const ServerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create server.
         * @param {NewServer} [newServer] New server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServer: (newServer, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/servers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(newServer, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete server.
         * @param {string} serverName Server name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServer: (serverName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'serverName' is not null or undefined
            (0, common_1.assertParamExists)('deleteServer', 'serverName', serverName);
            const localVarPath = `/servers/{server-name}`
                .replace(`{${"server-name"}}`, encodeURIComponent(String(serverName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get server.
         * @param {string} serverName Server name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServer: (serverName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'serverName' is not null or undefined
            (0, common_1.assertParamExists)('getServer', 'serverName', serverName);
            const localVarPath = `/servers/{server-name}`
                .replace(`{${"server-name"}}`, encodeURIComponent(String(serverName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all servers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listServers: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/servers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update server.
         * @param {string} serverName Server name.
         * @param {ServerUpdate} [serverUpdate] Server update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateServer: (serverName, serverUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'serverName' is not null or undefined
            (0, common_1.assertParamExists)('updateServer', 'serverName', serverName);
            const localVarPath = `/servers/{server-name}`
                .replace(`{${"server-name"}}`, encodeURIComponent(String(serverName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(serverUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ServerApiAxiosParamCreator = ServerApiAxiosParamCreator;
/**
 * ServerApi - functional programming interface
 * @export
 */
const ServerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ServerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create server.
         * @param {NewServer} [newServer] New server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServer(newServer, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createServer(newServer, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete server.
         * @param {string} serverName Server name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServer(serverName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteServer(serverName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get server.
         * @param {string} serverName Server name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServer(serverName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getServer(serverName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all servers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listServers(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listServers(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update server.
         * @param {string} serverName Server name.
         * @param {ServerUpdate} [serverUpdate] Server update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateServer(serverName, serverUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateServer(serverName, serverUpdate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ServerApiFp = ServerApiFp;
/**
 * ServerApi - factory interface
 * @export
 */
const ServerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ServerApiFp)(configuration);
    return {
        /**
         *
         * @summary Create server.
         * @param {NewServer} [newServer] New server.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServer(newServer, options) {
            return localVarFp.createServer(newServer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete server.
         * @param {string} serverName Server name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServer(serverName, options) {
            return localVarFp.deleteServer(serverName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get server.
         * @param {string} serverName Server name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServer(serverName, options) {
            return localVarFp.getServer(serverName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all servers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listServers(options) {
            return localVarFp.listServers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update server.
         * @param {string} serverName Server name.
         * @param {ServerUpdate} [serverUpdate] Server update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateServer(serverName, serverUpdate, options) {
            return localVarFp.updateServer(serverName, serverUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ServerApiFactory = ServerApiFactory;
/**
 * ServerApi - object-oriented interface
 * @export
 * @class ServerApi
 * @extends {BaseAPI}
 */
class ServerApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create server.
     * @param {NewServer} [newServer] New server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    createServer(newServer, options) {
        return (0, exports.ServerApiFp)(this.configuration).createServer(newServer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete server.
     * @param {string} serverName Server name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    deleteServer(serverName, options) {
        return (0, exports.ServerApiFp)(this.configuration).deleteServer(serverName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get server.
     * @param {string} serverName Server name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    getServer(serverName, options) {
        return (0, exports.ServerApiFp)(this.configuration).getServer(serverName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all servers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    listServers(options) {
        return (0, exports.ServerApiFp)(this.configuration).listServers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update server.
     * @param {string} serverName Server name.
     * @param {ServerUpdate} [serverUpdate] Server update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerApi
     */
    updateServer(serverName, serverUpdate, options) {
        return (0, exports.ServerApiFp)(this.configuration).updateServer(serverName, serverUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ServerApi = ServerApi;
/**
 * TopicApi - axios parameter creator
 * @export
 */
const TopicApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create topic.
         * @param {NewTopic} [newTopic] New topic.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopic: (newTopic, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/topics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(newTopic, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add group as a topic member.
         * @param {string} topicName Topic name.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopicMembership: (topicName, groupName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('createTopicMembership', 'topicName', topicName);
            // verify required parameter 'groupName' is not null or undefined
            (0, common_1.assertParamExists)('createTopicMembership', 'groupName', groupName);
            const localVarPath = `/topics/{topic-name}/group-memberships/{group-name}`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)))
                .replace(`{${"group-name"}}`, encodeURIComponent(String(groupName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete topic.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic: (topicName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('deleteTopic', 'topicName', topicName);
            const localVarPath = `/topics/{topic-name}`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Remove the group from the topic members.
         * @param {string} topicName Topic name.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicMembership: (topicName, groupName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('deleteTopicMembership', 'topicName', topicName);
            // verify required parameter 'groupName' is not null or undefined
            (0, common_1.assertParamExists)('deleteTopicMembership', 'groupName', groupName);
            const localVarPath = `/topics/{topic-name}/group-memberships/{group-name}`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)))
                .replace(`{${"group-name"}}`, encodeURIComponent(String(groupName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get topic.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopic: (topicName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('getTopic', 'topicName', topicName);
            const localVarPath = `/topics/{topic-name}`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the topic membership details.
         * @param {string} topicName Topic name.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicMembershipOfTopic: (topicName, groupName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('getTopicMembershipOfTopic', 'topicName', topicName);
            // verify required parameter 'groupName' is not null or undefined
            (0, common_1.assertParamExists)('getTopicMembershipOfTopic', 'groupName', groupName);
            const localVarPath = `/topics/{topic-name}/group-memberships/{group-name}`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)))
                .replace(`{${"group-name"}}`, encodeURIComponent(String(groupName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all topic member groups.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopicMembershipsByTopic: (topicName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('listTopicMembershipsByTopic', 'topicName', topicName);
            const localVarPath = `/topics/{topic-name}/group-memberships/`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all topics.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopics: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/topics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update topic.
         * @param {string} topicName Topic name.
         * @param {TopicUpdate} [topicUpdate] Topic update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic: (topicName, topicUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'topicName' is not null or undefined
            (0, common_1.assertParamExists)('updateTopic', 'topicName', topicName);
            const localVarPath = `/topics/{topic-name}`
                .replace(`{${"topic-name"}}`, encodeURIComponent(String(topicName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(topicUpdate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TopicApiAxiosParamCreator = TopicApiAxiosParamCreator;
/**
 * TopicApi - functional programming interface
 * @export
 */
const TopicApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TopicApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create topic.
         * @param {NewTopic} [newTopic] New topic.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopic(newTopic, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createTopic(newTopic, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Add group as a topic member.
         * @param {string} topicName Topic name.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopicMembership(topicName, groupName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createTopicMembership(topicName, groupName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete topic.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic(topicName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTopic(topicName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Remove the group from the topic members.
         * @param {string} topicName Topic name.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicMembership(topicName, groupName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTopicMembership(topicName, groupName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get topic.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopic(topicName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTopic(topicName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the topic membership details.
         * @param {string} topicName Topic name.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicMembershipOfTopic(topicName, groupName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTopicMembershipOfTopic(topicName, groupName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all topic member groups.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopicMembershipsByTopic(topicName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTopicMembershipsByTopic(topicName, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all topics.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopics(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTopics(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update topic.
         * @param {string} topicName Topic name.
         * @param {TopicUpdate} [topicUpdate] Topic update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic(topicName, topicUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTopic(topicName, topicUpdate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.TopicApiFp = TopicApiFp;
/**
 * TopicApi - factory interface
 * @export
 */
const TopicApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TopicApiFp)(configuration);
    return {
        /**
         *
         * @summary Create topic.
         * @param {NewTopic} [newTopic] New topic.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopic(newTopic, options) {
            return localVarFp.createTopic(newTopic, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add group as a topic member.
         * @param {string} topicName Topic name.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopicMembership(topicName, groupName, options) {
            return localVarFp.createTopicMembership(topicName, groupName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete topic.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic(topicName, options) {
            return localVarFp.deleteTopic(topicName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove the group from the topic members.
         * @param {string} topicName Topic name.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicMembership(topicName, groupName, options) {
            return localVarFp.deleteTopicMembership(topicName, groupName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get topic.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopic(topicName, options) {
            return localVarFp.getTopic(topicName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the topic membership details.
         * @param {string} topicName Topic name.
         * @param {string} groupName Group name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicMembershipOfTopic(topicName, groupName, options) {
            return localVarFp.getTopicMembershipOfTopic(topicName, groupName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all topic member groups.
         * @param {string} topicName Topic name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopicMembershipsByTopic(topicName, options) {
            return localVarFp.listTopicMembershipsByTopic(topicName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all topics.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTopics(options) {
            return localVarFp.listTopics(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update topic.
         * @param {string} topicName Topic name.
         * @param {TopicUpdate} [topicUpdate] Topic update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic(topicName, topicUpdate, options) {
            return localVarFp.updateTopic(topicName, topicUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TopicApiFactory = TopicApiFactory;
/**
 * TopicApi - object-oriented interface
 * @export
 * @class TopicApi
 * @extends {BaseAPI}
 */
class TopicApi extends base_1.BaseAPI {
    /**
     *
     * @summary Create topic.
     * @param {NewTopic} [newTopic] New topic.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    createTopic(newTopic, options) {
        return (0, exports.TopicApiFp)(this.configuration).createTopic(newTopic, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add group as a topic member.
     * @param {string} topicName Topic name.
     * @param {string} groupName Group name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    createTopicMembership(topicName, groupName, options) {
        return (0, exports.TopicApiFp)(this.configuration).createTopicMembership(topicName, groupName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete topic.
     * @param {string} topicName Topic name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    deleteTopic(topicName, options) {
        return (0, exports.TopicApiFp)(this.configuration).deleteTopic(topicName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove the group from the topic members.
     * @param {string} topicName Topic name.
     * @param {string} groupName Group name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    deleteTopicMembership(topicName, groupName, options) {
        return (0, exports.TopicApiFp)(this.configuration).deleteTopicMembership(topicName, groupName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get topic.
     * @param {string} topicName Topic name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    getTopic(topicName, options) {
        return (0, exports.TopicApiFp)(this.configuration).getTopic(topicName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the topic membership details.
     * @param {string} topicName Topic name.
     * @param {string} groupName Group name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    getTopicMembershipOfTopic(topicName, groupName, options) {
        return (0, exports.TopicApiFp)(this.configuration).getTopicMembershipOfTopic(topicName, groupName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all topic member groups.
     * @param {string} topicName Topic name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    listTopicMembershipsByTopic(topicName, options) {
        return (0, exports.TopicApiFp)(this.configuration).listTopicMembershipsByTopic(topicName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all topics.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    listTopics(options) {
        return (0, exports.TopicApiFp)(this.configuration).listTopics(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update topic.
     * @param {string} topicName Topic name.
     * @param {TopicUpdate} [topicUpdate] Topic update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicApi
     */
    updateTopic(topicName, topicUpdate, options) {
        return (0, exports.TopicApiFp)(this.configuration).updateTopic(topicName, topicUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TopicApi = TopicApi;
